import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Person } from '../../models/index';
import * as _ from 'lodash';

@Component({
    selector: 'edit-accessrights',
    templateUrl: './edit.component.html',
    standalone: false
})
export class AccessRightsEditComponent implements OnInit {
  @Input()
  public people: Person[];
  @Input()
  public accessRights: any[];
  @Input()
  public columns: string[];
  public personId: string = '';
  @Input()
  public processing: boolean;

  public peopleById: any;

  @Output()
  public toggleSaveAccessRights: EventEmitter<any> = new EventEmitter();
  @Output()
  public toggleCancel: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public save() {
    this.toggleSaveAccessRights.emit(this.accessRights);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  public remove(index: number) {
    this.accessRights.splice(index, 1);
  }

  public add() {
    if (!this.personId) return;
    let rights: any = {};
    _.each(this.columns, (col) => {
      rights[col] = -100;
    });
    this.accessRights.push({ id: '', ownerId: this.personId, rights: rights });
    this.personId = null;
  }

  public isOwner(item: any): boolean {
    return item.isOwner;
  }

  public hasRight(item: any, col: string): boolean {
    return item.rights[col] === 100;
  }

  public updateAccessRights(item: any, col: string) {
    if (this.hasRight(item, col)) {
      item.rights[col] = -100;
    } else {
      item.rights[col] = 100;
    }
  }

  public updateOwner(item: any) {}

  public getPersonName(item: any) {
    if (!this.peopleById) {
      this.peopleById = _.keyBy(this.people, (p: any) => p.id);
    }
    return this.peopleById[item.ownerId].name;
  }
}
